import {
  InvalidateQueryFilters,
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { PRODUCT_CATEGORIES_ENDPOINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO, SimpleResponseDTO } from "interface";
import { toast } from "react-toastify";

type DeleteProductCategory = {
  id: number;
};

type QueryOptionsWithoutMutationFn = Omit<
  UseMutationOptions<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    DeleteProductCategory,
    unknown
  >,
  "mutationFn"
>;

export const useDeleteProductCategory = (
  options?: QueryOptionsWithoutMutationFn
) => {
  const queryClient = useQueryClient();

  return useMutation<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    DeleteProductCategory
  >({
    retry: 0,
    ...options,
    mutationFn: async (data: DeleteProductCategory) => {
      const result = await instance.delete<SimpleResponseDTO<number>>(
        `${PRODUCT_CATEGORIES_ENDPOINTS.delete}?id=${data.id}`
      );

      return result.data;
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries([
        PRODUCT_CATEGORIES_ENDPOINTS.list,
      ] as InvalidateQueryFilters);
      toast.success(`دسته بندی با موفقیت حذف گردید`);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در حذف دسته بندی"}`);
    },
  });
};
